import {AudioManager, AudioType} from '@colonist/audio'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {createDivIn, createFormIn, createInputIn, createSpanIn, setElementInnerHTML, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {TranslationObject} from '@colonist/i18n'

export class ViewPopupInput extends ViewPopup {
    protected readonly form: HTMLFormElement
    private readonly inputWrapper: HTMLDivElement
    protected readonly input: HTMLInputElement
    private characterCounter: HTMLSpanElement
    protected readonly inputCheckAction: (value: string) => void

    constructor(title: TranslationObject, body: TranslationObject, checkAction: (value: string) => void, xAction: () => void, canCancel: boolean) {
        super(title, body, () => undefined, xAction, canCancel)
        this.inputCheckAction = checkAction

        this.body.classList.add('popup-input')

        this.form = createFormIn(this.body, '', '')

        this.inputWrapper = createDivIn(this.form, 'input-wrapper')
        this.input = createInputIn(this.inputWrapper, '', 'popupInput')
        this.input.type = 'text'
        this.input.autocomplete = 'off'
        this.input.autocapitalize = 'off'

        this.form.onsubmit = (e) => {
            e.preventDefault()
            this.checkAction()
        }

        setElementOnClick(this.checkButton, () => this.checkAction())
        this.createCheckOpacity()
    }

    private createCheckOpacity() {
        this.input.addEventListener('input', () => {
            this.updateCheckButtonState()
        })
    }

    protected updateCheckButtonState() {
        if(this.input.validity.valid) {
            this.checkButton.style.opacity = '1'
            this.checkButton.style.pointerEvents = 'auto'
        } else {
            this.checkButton.style.opacity = '0.5'
            this.checkButton.style.pointerEvents = 'none'
        }
    }

    protected inputLengthIsInRange(): boolean {
        return this.input.value.length >= this.input.minLength && this.input.value.length <= this.input.maxLength
    }

    protected checkAction() {
        AudioManager.play(AudioType.Click)
        if(this.input.validity.valid) {
            this.inputCheckAction(this.input.value)
            this.removePopup()
        }
    }

    setDefaultValue(value: string) {
        this.input.value = value
    }

    setPlaceholder(value: string) {
        this.input.placeholder = value
    }

    setLengthLimits(min: number, max: number) {
        this.input.minLength = min
        this.input.maxLength = max
    }

    setCharacterCounter() {
        if(this.characterCounter != undefined) return

        const currLength = this.input.value.length
        const maxLength = this.input.maxLength

        this.characterCounter = createSpanIn(this.inputWrapper, 'character-counter', {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {value: `${currLength}/${maxLength}`},
        })

        this.input.addEventListener('input', () => {
            this.updateCharacterCounter()
        })
    }

    updateCharacterCounter() {
        const currLength = this.input.value.length
        const minLength = this.input.minLength
        const maxLength = this.input.maxLength

        setElementInnerHTML(this.characterCounter, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {value: `${currLength}/${maxLength}`},
        })

        if(currLength < minLength) {
            this.characterCounter.classList.add('invalid')
            return
        }
        this.characterCounter.classList.remove('invalid')
    }
}
